function composeBaseQueryKey(schema, parameters, infinite) {
    return [
        typeof infinite === 'boolean' ? {
            ...schema,
            infinite
        } : schema,
        parameters ?? {}
    ];
}

export { composeBaseQueryKey };
//# sourceMappingURL=composeBaseQueryKey.js.map
